import React, { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Header, Footer } from './components';
import Home from './pages/Home';
import { initGA, logPageView } from './config/analytics';
import './styles/global.css';
import CookieConsent from './components/CookieConsent';
import { getLang, setLang } from './lang';

// Lazy load other pages
const Proyectos = lazy(() => import('./pages/Proyectos'));
const Equipo = lazy(() => import('./pages/Equipo'));
const Contacto = lazy(() => import('./pages/Contacto'));

// Define route mappings
const routes = {
  es: {
    home: '/',
    projects: '/proyectos',
    team: '/equipo',
    contact: '/contacto'
  },
  en: {
    home: '/en/home',
    projects: '/en/projects',
    team: '/en/team',
    contact: '/en/contact'
  }
};

// Wrapper component for English Home
const EnglishHome: React.FC = () => {
    useEffect(() => {
        // Solo establecer el idioma si no está ya en inglés
        if (getLang() !== 'en') {
            setLang('en');
        }
    }, []);
    
    return <Home />;
};

const App: React.FC = () => {
    const [currentLanguage, setCurrentLanguage] = useState(getLang());

    useEffect(() => {
        const cookieConsent = localStorage.getItem('cookieConsent');
        if (cookieConsent === 'true') {
            // Solo inicializar GA si el usuario ha aceptado las cookies
            initGA();
            logPageView();
        }
    }, []);

    return (
        <Router>
            <div className="app">
                <Header />
                <main>
                    <Suspense fallback={<div style={{ padding: '50px', textAlign: 'center' }}>Cargando...</div>}>
                        <Switch>
                            {/* Spanish Routes */}
                            <Route path="/" exact component={Home} />
                            <Route path="/proyectos" exact component={Proyectos} />
                            <Route path="/equipo" exact component={Equipo} />
                            <Route path="/contacto" exact component={Contacto} />
                            
                            {/* English Routes */}
                            <Route path="/en/home" exact component={EnglishHome} />
                            <Route path="/en/projects" exact component={Proyectos} />
                            <Route path="/en/team" exact component={Equipo} />
                            <Route path="/en/contact" exact component={Contacto} />
                            
                            {/* Redirect unknown paths to home in current language */}
                            <Route path="*">
                                <Redirect to={currentLanguage === 'en' ? '/en/home' : '/'} />
                            </Route>
                        </Switch>
                    </Suspense>
                </main>
                <Footer />
                <CookieConsent />
            </div>
        </Router>
    );
};

export default App;